import { ca } from '@cian/analytics';

export function trackPushNotificationEnable() {
  ca('eventSite', {
    action: 'Send',
    category: 'subscription',
    label: 'From_card_ChangePrice_first/PushOn',
  });
}
